import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=50a8e158"
import script from "./Container.vue?vue&type=script&setup=true&lang=js"
export * from "./Container.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports